//React
import React from "react";
import PropTypes from "prop-types";
import { SelectButton } from "primereact/selectbutton";
//CSS
import "./inputs.scss";

/**
 * Segmented control (ASB-3988): a row of mutually exclusive options, e.g.
 * "Enter Keywords | Pick Topics" or "Form | JSON". Wraps PrimeReact's
 * SelectButton the way table/dataTable.js wraps DataTable — consumers import
 * this, never PrimeReact, and the theme lives once under `.as-segmented`.
 * `onChange` receives the value, not PrimeReact's event.
 */
function SegmentedControl({
	value,
	onChange,
	options,
	optionLabel,
	optionValue,
	disabled,
	allowEmpty,
	ariaLabel,
	className,
}) {
	return (
		<SelectButton
			value={value}
			options={options}
			optionLabel={optionLabel}
			optionValue={optionValue}
			disabled={disabled ?? false}
			allowEmpty={allowEmpty ?? false}
			unselectable={allowEmpty ?? false}
			aria-label={ariaLabel}
			className={["as-segmented", className ?? ""].join(" ").trim()}
			onChange={(e) => {
				if (e.value === null || e.value === undefined) {
					if (allowEmpty && onChange) onChange(null);
					return;
				}
				if (onChange) onChange(e.value);
			}}
		/>
	);
}

SegmentedControl.propTypes = {
	value: PropTypes.any,
	/** (value) => void */
	onChange: PropTypes.func,
	/** strings, or objects read via optionLabel/optionValue */
	options: PropTypes.array.isRequired,
	optionLabel: PropTypes.string,
	optionValue: PropTypes.string,
	disabled: PropTypes.bool,
	/** allow clicking the active option to clear it; default false */
	allowEmpty: PropTypes.bool,
	ariaLabel: PropTypes.string,
	className: PropTypes.string,
};

export default SegmentedControl;
